import { render } from "./BrandManagement.vue?vue&type=template&id=30bfeee3&scoped=true"
import script from "./BrandManagement.vue?vue&type=script&lang=js"
export * from "./BrandManagement.vue?vue&type=script&lang=js"

import "./BrandManagement.vue?vue&type=style&index=0&id=30bfeee3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bfeee3"]])

export default __exports__